// Employer subscription catalog. Prices revealed Feb 2026 (iter-156).
//
// Starter + Growth both include a 14-day free trial — a credit card is
// REQUIRED at signup. On day 15 Stripe charges the card unless the
// subscription is cancelled first (see routers/stripe_billing.py).
// Single unconditional policy for every employer signup — no grandfathering.
export const EMPLOYER_PRICING_GATE = "Contact us";
export const EMPLOYER_TRIAL_INTRO = "Both plans include a 14-day free trial. A credit card is required to start — your card is charged on day 15 unless you cancel before then.";
// Per-plan sentence template; <PLAN_PRICE> is interpolated at render time
// (see components/pricing/EmployerSubscriptionSection.jsx).
export const EMPLOYER_TRIAL_TERMS_TEMPLATE = "14-day free trial — credit card required to start. Your card will be charged <PLAN_PRICE>/month on day 15 unless you cancel before then. Cancel anytime in your account — no charge if you cancel before day 15.";
// Legacy export kept so older imports (TrialBanner, EmployerBilling banner)
// render the pre-interpolation sentence without crashing. New code should
// use EMPLOYER_TRIAL_TERMS_TEMPLATE and interpolate the plan price.
export const EMPLOYER_TRIAL_TERMS = EMPLOYER_TRIAL_TERMS_TEMPLATE.replace("<PLAN_PRICE>", "$99 or $249");

export const EMPLOYER_PLANS = [
    {
        key: "starter", name: "Starter",
        description: "For small businesses making their next key hire.",
        priceLabel: "$99", period: "/month",
        planKey: "employer_starter_month",
        cta: "Start 14-day free trial",
        trialDays: 14,
        features: [
            "2 active jobs",
            "AI job parsing",
            "AI Hiring Brief™",
            "AI matching",
            "5 Talent Passport™ matches per job",
            "candidate sharing",
            "notes",
            "interview scheduling",
            "1 employer seat",
        ],
    },
    {
        key: "growth", name: "Growth",
        description: "For growing teams hiring on repeat.",
        priceLabel: "$249", period: "/month",
        planKey: "employer_growth_month",
        cta: "Start 14-day free trial",
        trialDays: 14,
        highlight: true,
        features: [
            "unlimited jobs",
            "unlimited AI Hiring Briefs™",
            "AI matching",
            "25 Talent Passport™ matches per job",
            "team collaboration",
            "candidate comparisons",
            "Google Calendar + Outlook integrations",
            "4 team members",
        ],
    },
];

// iter-156 — makes the two paths unmistakable. Subscription = self-serve
// software; Simonara Recruit = 1:1 consultation with a Simonara recruiter.
export const SUBSCRIPTION_PLACEMENT_COPY = "Two ways to hire on Simonara. Pick one, or run both in parallel. (1) Subscribe to Starter or Growth and run the hire yourself — AI matching, Hiring Briefs, Talent Passports, team collaboration. (2) Simonara Recruit™ — book a 1:1 with a real Simonara recruiter who sources, screens, and shortlists candidates for a specific role; finalist background checks are run at the offer stage by our team. The first 10 founding employers lock in a 12% Recruit placement fee for every hire, forever — everyone after pays 15%.";
